'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const AddPackageLinkIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="AddPackageLinkIcon">
      <svg width="24" height="9" viewBox="0 0 24 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.5 6.5C13.5 7.03043 13.7107 7.53914 14.0858 7.91421C14.4609 8.28929 14.9696 8.5 15.5 8.5H20.5C21.295 8.49789 22.0568 8.18114 22.619 7.61899C23.1811 7.05684 23.4979 6.295 23.5 5.5V3.5C23.4976 2.70508 23.1808 1.9434 22.6187 1.3813C22.0566 0.819207 21.2949 0.502374 20.5 0.5H15.5C14.9696 0.5 14.4609 0.710714 14.0858 1.08579C13.7107 1.46086 13.5 1.96957 13.5 2.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 6.5C10.5 7.03043 10.2893 7.53914 9.91421 7.91421C9.53914 8.28929 9.03043 8.5 8.5 8.5H3.5C2.705 8.49789 1.94316 8.18114 1.38101 7.61899C0.81886 7.05684 0.502112 6.295 0.5 5.5V3.5C0.502374 2.70508 0.819207 1.9434 1.3813 1.3813C1.9434 0.819207 2.70508 0.502374 3.5 0.5H8.5C9.03043 0.5 9.53914 0.710714 9.91421 1.08579C10.2893 1.46086 10.5 1.96957 10.5 2.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 4.49902H17.5"
          stroke="#3D517B"
          strokeOpacity="0.560784"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

AddPackageLinkIcon.propTypes = {
  sx: PropTypes.object
}
